/**
 * Clave pública ECDSA P-256 para verificar códigos de activación.
 * Generada con practicaja/admin/generar-clave.js
 * La clave PRIVADA nunca sale de la herramienta admin.
 */
export const PUBLIC_KEY_JWK = {
  key_ops: ['verify'],
  ext: true,
  kty: 'EC',
  x: 'aOeHZB1JNKJd90wiCkV3ej0Zn9-b-X6pkAVZwjTQnqA',
  y: 'sFrRo-3ZOC_yBvsOU_KfMlsBTtrREb2yfOLRbvjBQG4',
  crv: 'P-256',
}

/** Duración del periodo de prueba en días */
export const DIAS_TRIAL = 30
